import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { useRadioChannelData } from "../../../hook/useRadioChannelData";
import { NotFoundPage } from "../not-found";
import "./radio-channel-page.m.css";

const RadioChannelPage = (props) => {

  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], ""));
  const channelSlug = currentPath.replace("/radiot-", "").split("?")[0].split("/")[0] || "";

  const { channelData, loading, error } = useRadioChannelData(
    `mobile-radio-${channelSlug}`,
    props.data?.radioChannelData
  );

  // Soft 404 handling: if API fails or returns no data (e.g. /radiot-moon)
  if (error || (!loading && !channelData)) {
    return <NotFoundPage />;
  }

  const content = channelData?.content || [];

  const capitalizeFirstLetter = (string) => (string ? string.charAt(0).toUpperCase() + string.slice(1) : "");
  const CapitalizedSlug = capitalizeFirstLetter(channelSlug);

  // Linux case-sensitive image mapping
  const imageMap = {
    helsinki: { hero: "Helsinki-herojpg.jpg", mob: "Helsinki-heromobiili.jpg" },
    kajaani: { hero: "Kajaani-hero.jpg", mob: "Kajaani-heromobiili.jpg" },
    lohja: { hero: "Lohja-hero.jpg", mob: "Lohja-Heromobiili.jpg" },
    oulu: { hero: "Oulu-hero.jpg", mob: "Oulu-heromobiili.jpg" },
    pohjanmaa: { hero: "Pohjanmaa-hero.jpg", mob: "Pohjanmaa-heromobiili.jpg" },
    rovaniemi: { hero: "Rovaniemi-hero.jpg", mob: "Rovaniemi-heromobiili.jpg" },
    turku: { hero: "Turku-hero.jpg", mob: "Turku-heromobiili.jpg" },
    valtakunnallinen: { hero: "Valtakunnallinen-hero.jpg", mob: "Valtakunnallinen-heromobiili.jpg" },
  };

  const images = imageMap[channelSlug.toLowerCase()] || {
    hero: `${CapitalizedSlug}-hero.jpg`,
    mob: `${CapitalizedSlug}-heromobiili.jpg`,
  };

  // Dynamic texts with fallback to old hardcoded text
  const heroHeading = channelData?.heroHeading || `Radio Dei ${CapitalizedSlug}`;
  const heroSubtitle = channelData?.heroSubtitle || "Uskoa, toivoa ja yhteyttä.";

  // Find the first heading from the CMS, fallback to the hardcoded slug
  const firstHeadingText =
    content.find((item) => item.type === "heading" || item.type === "subheading")?.text ||
    `Radio Dei ${CapitalizedSlug}`;

  return (
    <>
      <div styleName="top-banner-static-image">
        <div styleName="custom-hero-heading">
          <h3>{heroHeading}</h3>
          <p>{heroSubtitle}</p>
        </div>

        <img src={`/assets/${images.hero}`} styleName="big-desktop-image" />
        <img src={`/assets/${images.mob}`} styleName="portrait-mobile-image" />

        <div styleName="contentTitle">
          <div styleName="main-headline-content">
            <div>
              <h1>{firstHeadingText}</h1>
            </div>
            <div styleName="mhz">
              <h2>{channelData?.frequency}</h2>
            </div>
          </div>
        </div>
      </div>

      <div styleName="radio-container">
        <div styleName="staticContent">
          <div styleName="columnLeft">
            <h2 styleName="firstH2">{firstHeadingText}</h2>

            {/* The Dynamic Content Loop */}
            {content.map((item, index) => {
              // We skip rendering the first heading again, since we just rendered it manually above!
              if (item.text === firstHeadingText) return null;

              if (item.type === "paragraph") return <p key={index}>{item.text}</p>;
              if (item.type === "heading" || item.type === "subheading") return <h2 key={index}>{item.text}</h2>;
              return null;
            })}
          </div>
          <div styleName="columnRight">
            {/* Desktop Map */}
            <div
              styleName="map-hero-container big-desktop-image"
              style={{ backgroundImage: `url('/assets/${CapitalizedSlug}-web.jpg')` }}
            >
              &nbsp;
            </div>

            {/* Mobile Map */}
            <div
              styleName="map-hero-container portrait-mobile-image"
              style={{ backgroundImage: `url('/assets/${CapitalizedSlug}-mobile.jpg')` }}
            >
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { RadioChannelPage };
